import { AutoComplete, Button, Form, Input, Modal, Select, Spin } from "antd";
import React, { useState } from "react";
import { dispatchtoast, filterOption } from "../../../Utils";
import CommonInput from "../../../Common/CommonInput";
import {
  BalanceTransfer,
  debitcreditfund,
  MemberList,
} from "../../../ApiServices/Apifun";

const DebitCreditModal = ({ open, setopen, apiCall, record }) => {
  const [btnLoading, setBtnLoading] = useState(false);
  const [spin, setSpin] = useState(false);
  const [memberId, setMemberId] = useState("");
  const [selectedOne, setSelectedOne] = useState(null);
  const [paidStatus, setPaidStatus] = useState(false);

  const handleSend = (val) => {
    console.log(val, "val");
    setBtnLoading(true);
    const formdata = new FormData();
    formdata.append("member_id", record?.id);
    formdata.append("amount", val.amount);
    formdata.append("remark", val.remark);
    formdata.append("type", val.type);
    formdata.append("status", paidStatus ? 1 : 0);
    debitcreditfund(formdata)
      .then((res) => {
        if (res.status) {
          dispatchtoast(res.msg);
          setopen(false);
          apiCall();
        } else {
          dispatchtoast(res.msg, true);
          setopen(false);
          apiCall();
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setBtnLoading(false));
  };
  return (
    <>
      <Modal
        maskClosable={false}
        title="Debit Credit"
        footer={null}
        open={open}
        onCancel={() => setopen(false)}
      >
        <Spin spinning={spin}>
          <Form
            initialValues={{
              type: "Cr",
            }}
            onFinishFailed={(err) => console.log(err)}
            onFinish={(val) => handleSend(val)}
          >
            <div className="grid grid-cols-1 gap-x-3 place-items-center ">
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "Select Type",
                  },
                ]}
                name={"type"}
                label="Select Debit/Credit"
                labelCol={{ span: 24 }}
                className="w-full"
              >
                <Select
                  placeholder="Select  type"
                  className="w-full mt-2"
                  options={[
                    { label: "Debit", value: "Dr" },
                    { label: "Credit", value: "Cr" },
                  ]}
                />
              </Form.Item>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "Enter amount",
                  },
                ]}
                label="Amount"
                name={"amount"}
                labelCol={{ span: 24 }}
                className="w-full"
              >
                <CommonInput
                  onInput={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    e.target.value = value;
                  }}
                  placeholder="Amount"
                  className="outline-none text-xs border w-full  border-gray-200 focus:border-primary  h-8 px-2"
                />
              </Form.Item>
            </div>
            <Form.Item
              label="Paid"
              labelCol={{ span: 24 }}
              className="w-full mt-2"
            >
              <div className="mt-2 flex justify-start items-center gap-x-3  checkbox">
                <Input
                  checked={paidStatus}
                  onChange={(e) => setPaidStatus(!paidStatus)}
                  className="rounded-md"
                  type="checkbox"
                />
                <p className="text-textGray">Paid</p>
              </div>
            </Form.Item>
            <Form.Item
              label="Remark"
              name={"remark"}
              labelCol={{ span: 24 }}
              className="w-full mt-2"
            >
              <CommonInput
                placeholder="Remark"
                className="outline-none text-xs border w-full  border-gray-200 focus:border-primary  h-8 px-2"
              />
            </Form.Item>
            <div className="flex justify-end mt-4 items-center gap-x-4">
              <Form.Item>
                <Button
                  className="bg-primary text-white hover:border-none border-none"
                  loading={btnLoading}
                  htmlType="submit"
                >
                  Submit
                </Button>
              </Form.Item>
            </div>
          </Form>
        </Spin>
      </Modal>
    </>
  );
};

export default DebitCreditModal;
